require('sass/brands/stores.bestbuy.ca/search/default.scss');
require('js/search-script.js');
